"use client";
import { motion, useInView } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { useRef } from "react";

const cardVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.2,
      type: "spring",
      stiffness: 350,
    },
  }),
};

const Cards = ({ item, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <motion.div
      ref={ref}
      className="flex flex-col items-center space-y-2"
      variants={cardVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      custom={index}
    >
      <Link
        href={item.url}
        // item.url === "https://pgi.billdesk.com/pgidsk/pgmerc/kresco/KRESCODetails.jsp" 
        //   ||
        target= { item.url ===  "https://pgrs.ap.gov.in/"
          || item.url ===  "https://www.apspdcl.in/CGRF1/" || item.url === "https://play.google.com/store/apps/details?id=com.resco.consumer&pcampaignid=web_share"
          || item.url === "https://kuppamresco.org/ConsumerDashboard/serviceDetails.jsp"
          ? "_blank":""}
        className="group flex justify-center items-center bg-green-3 hover:bg-green-4 hover:text-white rounded-lg p-2 shadow-lg motion border border-green-14 hover:border-green-5"
      >
        <Image
          src={item.image}
          alt={item.title}
          width={100}
          height={100}
          sizes="(max-width: 1024px) 64px, (max-width: 1280px) 160px, 200px"
          className="w-16 h-16 xl:w-[70px] xl:h-[70px] 2xl:w-24 2xl:h-24 group-hover:scale-115 group-hover:rotate-[0.2rad] group-hover:duration-300 object-cover rounded-full transition-transform duration-300"
        />
      </Link>
      <p className="w-32 text-sm font-medium text-center">{item.title}</p>
    </motion.div>
  );
};

export default Cards;
